export default {
  methods: {
    getContextMenuItems(params) {
      return [
        'copy',
        'copyWithHeaders',
        'separator',
        {
          // custom item
          name: 'Export',
          action: () => {
            // Erste zwei Spalten entfallen, "Detail Link" und "Image" sind im Export nicht erwünscht
            // Hier werden aktuell sichtbare Columns selektiert
            var columns = this.gridColumnApi.getColumns();
            columns.splice(0, 2);
            this.gridApi.exportDataAsExcel({columnKeys: columns});
          },
          icon: '<i class="far fa-file-download"></i>'
        }
      ]
    }
  }
}
